import React, { useState } from 'react';
import apiService from '../../services/apiService';
import './StripeOnboardingMessage.css';

const StripeOnboardingMessage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCompleteOnboarding = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await apiService.getStripeOnboardingUrl();
      
      // Redirect user to Stripe onboarding URL
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      } else {
        throw new Error('No onboarding URL provided');
      }
    } catch (error) {
      console.error('Error getting Stripe onboarding URL:', error);
      setError(error.message || 'Failed to get Stripe onboarding URL');
      setLoading(false);
    }
  };

  return (
    <div className="stripe-onboarding-message">
      <div className="stripe-onboarding-content">
        <h3>Complete Your Payment Setup</h3>
        <p>To manage zones and accept payments, you need to complete your Stripe account setup.</p>
        
        {error && <div className="onboarding-error">{error}</div>}
        
        <button 
          className="onboarding-button" 
          onClick={handleCompleteOnboarding}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Complete Stripe Setup'}
        </button>
      </div>
    </div>
  );
};

export default StripeOnboardingMessage; 